export default "__VITE_ASSET__a3240782__"